import API from "..";

export const deleteUser = async (id: string) => API.delete<any>(`/user/${id}`);